import { useMutation } from 'react-query';
import { ReportDocumentTypesParams } from './Report.types';
import { generateDocumentTypeReport } from './Report.service';
import { useServiceError } from '@/hooks';

export function useDocumentTypeReport() {
  const mutation = useMutation((obj: ReportDocumentTypesParams) =>
    generateDocumentTypeReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}
